/** Single source of truth for supported blog canvas decor kinds. */
export const decorCanvasKinds = ['local-inference', 'asking', 'boids', 'diff'];

export const decorCanvasTypes = new Set(decorCanvasKinds);